
  import { Component, Vue, Ref } from 'vue-property-decorator';
  import { BModal, BFormInput } from 'bootstrap-vue';
  import Password from 'vue-password-strength-meter';
  import Captcha from '../Common/Captcha.vue';

  const INITIAL_FORM = {
    username: '',
    email: '',
    password: '',
    rePassword: '',
    validation: '',
  };

  @Component({
    components: {
      Captcha,
      Password,
    },
  })

  export default class RegisterModal extends Vue {
    form = INITIAL_FORM;

    loading = false;

    accepted: boolean = false;

    captchaResponse = null;

    errorMessage = '';

    attemptNumber: number = 0;

    score: number = 0;

    warning: string = '';

    registered: boolean = false;

    uid: string = '';

    @Ref() readonly modal!: BModal;

    @Ref() readonly rePassword!: BFormInput;

    async setScore(score: number) {
      this.score = score;
    }

    async setFeedback({warning}: {suggestions: string[], warning: string}) {
      this.warning = warning;
    }

    async tryRegister() {
      this.errorMessage = '';
      if (!this.accepted) {
        this.errorMessage = 'register-modal:error-accept-terms';
        return;
      }
      if (this.form.password !== this.form.rePassword) {
        this.errorMessage = 'register-modal:error-password-match';
        return;
      }
      if (this.form.username.includes('@')) {
        this.errorMessage = 'register-modal:error-at';
        return;
      }

      this.loading = true;
      await this.register();
    }

    async register() {
      // $('#loader').modal('show');
      const response = await this.$http.post(
        '/login/',
        new URLSearchParams({
          name: this.form.username,
          pass: this.form.password,
          mail: this.form.email,
          type: 'create',
          captcha_response: this.captchaResponse ? JSON.stringify(this.captchaResponse) : '',
        }),
        {
          headers: { 'Content-type': 'application/x-www-form-urlencoded' },
        },
      );
      const { data } = response;
      if (data.data.success) {
        this.registered = true;
        this.uid = data.data.uid;
      } else {
        this.errorMessage = data.data.error;
        this.attemptNumber += 1;
        this.captchaResponse = null;
        this.loading = false;
      }
    }

    async resend() {
      this.errorMessage = '';
      const response = await this.$http.post(
        '/login/',
        new URLSearchParams({
          name: this.form.username,
          uid: this.uid,
          mail: this.form.email,
          type: 'sendvalidation',
        }),
        {
          headers: { 'Content-type': 'application/x-www-form-urlencoded' },
        },
      );
      const { data } = response;
      if (!data.data.success) {
        this.errorMessage = data.data.error;
        this.attemptNumber += 1;
        this.captchaResponse = null;
        this.loading = false;
      }
    }
  }
